import { Checkbox } from '@acpaas-ui/react-components';
import _ from 'lodash';
import React, { useCallback } from 'react';

const TableBody = ({
  resourceKey,
  enableSelect,
  highlight,
  highlightType,
  onRowClick,
  disableRow,
  onSelect,
  selected = [],
  fields = [],
  data = []
}) => {
  const getRowClickHandler = useCallback(
    (data) => {
      if (disableRow && disableRow(data)) {
        return undefined;
      }
      return () => onRowClick(data);
    },
    [disableRow, onRowClick]
  );
  return (
    <tbody>
      {data.map((d, i) => (
        <tr
          key={`${resourceKey}_${d.id || i}`}
          className={
            highlight && highlight(d)
              ? `spo-o-table__row ${
                  disableRow ? (disableRow(d) ? 'spo-o-table__row--disabled' : '') : ''
                } spo-o-table__row--highlight ${highlightType ? `spo-o-table__row--highlight-${highlightType}` : ''}`
              : `spo-o-table__row ${disableRow ? (disableRow(d) ? 'spo-o-table__row--disabled' : '') : ''}`
          }
          onClick={getRowClickHandler(d)}
        >
          {enableSelect && (
            <td
              key={`${resourceKey}_select-${d.id}`}
              className="spo-o-table__row-select"
              onClick={(e) => e.stopPropagation()}
            >
              <Checkbox checked={selected?.includes(d.id)} onChange={() => onSelect(d.id)} />
            </td>
          )}
          {fields.map((f) => {
            const text = f.transform ? f.transform(_.get(d, f.value, ''), d) : _.get(d, f.value, '');
            return (
              <td key={f.value} title={text}>
                {text}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};

export default TableBody;
